import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "../css/productdetail.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Collapse from "react-bootstrap/Collapse";

function Productdetail() {
  const { state } = useLocation();
  const product = state?.product || null;

  const [openSections, setOpenSections] = useState({});

  console.log("Product data in Productdetail:", product); // Debug product data

  if (!product) {
    return <div>No product data available. Please select a product.</div>;
  }

  const toggleSection = (section) => {
    setOpenSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  return (
    <div className="product-details">
      {/* Hero Section */}
      <div className="product-detail-hero">
        <div className="product-detail-col1">
          <img src={product.image} alt={product.name || "Product Image"} />
        </div>
        <div className="product-detail-col2">
          <h2>{product.name || "Unnamed Product"}</h2>
          <h5>
            {product.type && `${product.type}`} {product.model && `| Model: ${product.model}`} {product.series && `| Series: ${product.series}`}
          </h5>
          {product.description && <p>{product.description}</p>}
          <div className="product-detail-button-group">
            <button>HOW TO BUY</button>
            <button>EMAIL PRODUCT DETAILS</button>
          </div>
          {product.company && <p><strong>Company:</strong> {product.company}</p>}
          {product.make_origin && <p><strong>Origin:</strong> {product.make_origin}</p>}
        </div>
      </div>

      {/* Specifications Section */}
      <div className="product-details-specification">
        <h2>Specifications of {product.name}</h2>
        <div className="specification-table-wrapper">
          <table>
            <thead>
              <tr>
                <th colSpan={2}>General</th>
              </tr>
            </thead>
            <tbody>
              {product.battery_life && (
                <tr>
                  <td>Battery Life</td>
                  <td>{product.battery_life}</td>
                </tr>
              )}
              {product.frequency_range && (
                <tr>
                  <td>Frequency Range</td>
                  <td>{product.frequency_range}</td>
                </tr>
              )}
              {product.power_output && (
                <tr>
                  <td>Power Output</td>
                  <td>{product.power_output}</td>
                </tr>
              )}
              {product.document && (
                <tr>
                  <td>Document</td>
                  <td>
                    <a href={product.document} target="_blank" rel="noopener noreferrer">
                      View Document
                    </a>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Related Products (Placeholder) */}
      <div className="product-details-related-products">
        <h2>Related Products</h2>
        <p>Related products can be fetched and displayed here.</p>
      </div>
    </div>
  );
}

export default Productdetail;